import { getRequestForMe, RequestResponse } from "@api";
import { FilterType, Table } from "@components";
import { Box } from "@material-ui/core";
import * as React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { Cell, Row } from "../../../components/table/types";
import { TABLE_HEADERS, TOOLTIPS } from "../constants";
import { useState } from "react";

const headers: Cell[] = [
  { data: TABLE_HEADERS.REF_NUMBER },
  { data: TABLE_HEADERS.REQUESTED_BY },
  { data: TABLE_HEADERS.SYSTEM_CATEGORY },
  { data: TABLE_HEADERS.DEVICE_TYPE },
  { data: TABLE_HEADERS.NAME, tooltip: TOOLTIPS.NAME },
  { data: TABLE_HEADERS.ROLE },
  { data: TABLE_HEADERS.ENVIRONMENT },
  { data: TABLE_HEADERS.STATUS },
  { data: TABLE_HEADERS.DATE_REQUESTED },
];

export const MyAccess: React.FC = () => {
  const history = useHistory();
  const [requests, setRequests] = React.useState<Row<RequestResponse>[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    getRequestForMe().then((req: RequestResponse[]) => {
      setRequests(
        req.map((r: RequestResponse, index) => {
          return {
            cells: [
              {
                data: r.referenceNumber,
                index: index,
                color: "blue",
                cursor: "pointer",
                onClick: () => {
                  history.push(`/dashboard/requests/${r.encryptId}`, {
                    readonlyAttestation: true,
                  });
                },
              },
              { data: r.requestor, index: index },
              { data: r.subCategory, index: index },
              { data: r.deviceType, index: index },
              { data: r.subCategory, index: index },
              { data: r.role, index: index },
              { data: r.environment, index: index },
              { data: r.status, index: index },
              { data: r.dateAdded, index: index },
            ],
            data: r,
          };
        })
      );
      setIsloading(false);
    });
  }, [history]);

  return (
    <Box mt={2}>
      <Table
        data={requests}
        tableName="My Access"
        searchPlaceholder="Search by Reference No"
        searchColumns={[TABLE_HEADERS.REF_NUMBER]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="MY_ACCESS_TOOLBAR"
        loading={isLoading}
        order="desc"
      />
    </Box>
  );
};
